import { render } from "./SliderComponent.vue?vue&type=template&id=78c6a05f"
import script from "./SliderComponent.vue?vue&type=script&lang=js"
export * from "./SliderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Slider/SliderComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78c6a05f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78c6a05f', __exports__)) {
    api.reload('78c6a05f', __exports__)
  }
  
  module.hot.accept("./SliderComponent.vue?vue&type=template&id=78c6a05f", () => {
    api.rerender('78c6a05f', render)
  })

}


export default __exports__